var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanZalaczniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grafika") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M88,32 L88,93.3333333 C88,105.12 78.4533333,114.666667 66.6666667,114.666667 C54.88,114.666667 45.3333333,105.12 45.3333333,93.3333333 L45.3333333,26.6666667 C45.3333333,19.3066667 51.3066667,13.3333333 58.6666667,13.3333333 C66.0266667,13.3333333 72,19.3066667 72,26.6666667 L72,82.6666667 C72,85.6 69.6,88 66.6666667,88 C63.7333333,88 61.3333333,85.6 61.3333333,82.6666667 L61.3333333,32 L53.3333333,32 L53.3333333,82.6666667 C53.3333333,90.0266667 59.3066667,96 66.6666667,96 C74.0266667,96 80,90.0266667 80,82.6666667 L80,26.6666667 C80,14.88 70.4533333,5.33333333 58.6666667,5.33333333 C46.88,5.33333333 37.3333333,14.88 37.3333333,26.6666667 L37.3333333,93.3333333 C37.3333333,109.546667 50.4533333,122.666667 66.6666667,122.666667 C82.88,122.666667 96,109.546667 96,93.3333333 L96,32 L88,32 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2.0-E-SPRAWOZDANIE---ZA\\u0141\\u0104CZNIKI---PUSTO",
    transform: "translate(-420.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace",
    transform: "translate(36.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Szambelan",
    transform: "translate(166.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grafika",
    transform: "translate(222.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 116,
    cy: 116,
    r: 116
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,232 C180.065031,232 232,180.065031 232,116 C232,51.934969 180.065031,0 116,0 C51.934969,0 0,51.934969 0,116",
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 8,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(116.000000, 116.000000) rotate(90.000000) translate(-116.000000, -116.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Attach-file",
    opacity: 0.384347098,
    transform: "translate(52.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Black-38%",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillOpacity: 0.38,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanZalaczniki);
export default __webpack_public_path__ + "static/media/szambelan_zalaczniki.7b6b985cc99cfbc5967eddf30ba314a4.svg";
export { ForwardRef as ReactComponent };